module.exports = __webpack_public_path__ + "static/media/plus_circle.e338d3c3.svg";